import { render } from "./AppInput.vue?vue&type=template&id=ce6a2ed2"
import script from "./AppInput.vue?vue&type=script&lang=js"
export * from "./AppInput.vue?vue&type=script&lang=js"

import exportComponent from "/Users/ferlando/Desktop/Baboon/baboon-pos/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__